/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegisterApiKeyRequestBody
 */
export interface RegisterApiKeyRequestBody {
    /**
     * The API secret (private key hex) for the developer app
     * @type {string}
     * @memberof RegisterApiKeyRequestBody
     */
    apiSecret: string;
}

/**
 * Check if a given object implements the RegisterApiKeyRequestBody interface.
 */
export function instanceOfRegisterApiKeyRequestBody(value: object): value is RegisterApiKeyRequestBody {
    let isInstance = true;
    isInstance = isInstance && "apiSecret" in value && value["apiSecret"] !== undefined;

    return isInstance;
}

export function RegisterApiKeyRequestBodyFromJSON(json: any): RegisterApiKeyRequestBody {
    return RegisterApiKeyRequestBodyFromJSONTyped(json, false);
}

export function RegisterApiKeyRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterApiKeyRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'apiSecret': json['api_secret'],
    };
}

export function RegisterApiKeyRequestBodyToJSON(value?: RegisterApiKeyRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'api_secret': value.apiSecret,
    };
}

